import DatePicker from '@eversports/react-components/primitives/DatePicker'
import { Localized } from '../../../localization/react'

const INITIAL_SELECTED_AGE = 18

const Birthday = () => {
  const initialDate = new Date(new Date().setFullYear(new Date().getFullYear() - INITIAL_SELECTED_AGE))
  const maxDate = new Date()
  return (
    <DatePicker
      name="birthday"
      initialFocusedDate={initialDate}
      maxDate={maxDate}
      label={<Localized id="field-birthday" />}
      data-testid="required-information-birthday"
    />
  )
}

export default Birthday
